<template>
    <div class="main-con el-main">
        <router-view />
    </div>
</template>

<script>
export default {
    name: "FaihaiQueryView"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/FaihaiQueryView.vue